import { render } from "./MultistepPage.vue?vue&type=template&id=b3fc65b2&scoped=true"
import script from "./MultistepPage.vue?vue&type=script&lang=js"
export * from "./MultistepPage.vue?vue&type=script&lang=js"

import "./MultistepPage.vue?vue&type=style&index=0&id=b3fc65b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3fc65b2"]])

export default __exports__